import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { Route, Switch } from 'react-router-dom';
import { loadFacility, loadFacilityByPatientId } from '../redux/modules/facility/facility-middleware';
import { updateWindowSize } from '../redux/modules/window/window-middleware';
import { loadUserProfile } from '../redux/modules/user-profile/user-profile-middleware';
import PageLayout from '../containers/PageLayout';
import SingleSignOnLoginPage from '../pages/LoginPage/SingleSignOnLoginPage';
import SingleSignOnFailedPage from '../pages/LoginPage/SingleSignOnFailedPage';
import PatientKioskUserLoginPage from '../pages/LoginPage/PatientKioskUserLoginPage';

class AppContainer extends Component {
  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.handleResize);
    const { dispatch, isAuthenticated } = this.props;

    if (isAuthenticated) {
      dispatch(loadUserProfile());
    }
  }

  componentDidMount() {
    const { dispatch, patientId } = this.props;
    dispatch(updateWindowSize());
    if (patientId) {
      dispatch(loadFacilityByPatientId(patientId));
    } else {
      dispatch(loadFacility(document.URL));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.props.dispatch(updateWindowSize());
  }

  render() {
    const { language, translations } = this.props;

    if (translations == null) return null;

    return (
      <IntlProvider key={language} locale={language || 'en'} messages={translations}>
        <Switch>
          <Route path="/singleSignOn" component={SingleSignOnLoginPage} />
          <Route path="/patientKioskUserLogin" component={PatientKioskUserLoginPage} />
          <Route path="/singleSignOnFailed" component={SingleSignOnFailedPage} />
         <Route component={PageLayout} />
        </Switch>
      </IntlProvider>
    );
  }
}

AppContainer.propTypes = {
  language: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  patientId: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  translations: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  location: ownProps.location,
  language: state.language.languageCode,
  patientId: state.profile.patient.patientId,
  isAuthenticated: state.profile.auth.isAuthenticated,
  translations: state.language.translations,
});

export default connect(mapStateToProps)(AppContainer);